import Link from 'next/link';
import styles from './Header.module.css';
import useAuth from '../../context/authContext';
import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { Dropdown } from 'react-bootstrap';

function useOutsideAlerter(ref) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        document.getElementById('sidenav').style.left = '-250px';
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

export default function Header({ isAuth, user }) {
  const { isAuthenticated, logout } = useAuth();

  const [showDropDown, setShowDropDown] = useState(false);
  const hasAccess = isAuthenticated || isAuth;
  const { push, pathname: routePath } = useRouter();
  const wrapperRef = useRef(null);

  useOutsideAlerter(wrapperRef);

  const openNav = () => {
    document.getElementById('sidenav').style.left = '0';
  };

  const closeNav = () => {
    document.getElementById('sidenav').style.left = '-250px';
  };

  const isActive = (pathname) => routePath === pathname;

  const ordersLink =
    user?.user_type === 'student' || isAuth.user_type === 'student'
      ? '/student/orders'
      : '/tutor/orders';

  const isTutor = user?.user_type === 'tutor' && isAuth.user_type === 'tutor';

  const isHomePage = routePath === '/';

  return (
    <>
      <div
        className={`${styles.responsiveHeader} ${
          routePath === '/' ? styles.absolute : ''
        }`}
      >
        <img
          onClick={() => push('/')}
          src="/logo_dark.png"
          alt="logo"
          className={styles.logo}
        />
        <button className="navbar-toggler" type="button" onClick={openNav}>
          <i
            className="fas fa-bars p-3 bg-white text-dark"
            style={{
              borderRadius: '10px',
              boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
            }}
          />
        </button>
      </div>
      <div className="responsive-navbar" ref={wrapperRef} id="sidenav">
        <div className="responsive-navbar-header">
          <p className="menu-title">القائمة</p>
          <a href="#" className="closebtn" role="button" onClick={closeNav}>
            &times;
          </a>
        </div>
        <ul className="navbar-nav res-navbar-nav">
          {!isTutor && (
            <>
              <li className="nav-item res-nav-item active">
                <Link href="/" onClick={closeNav} className="nav-link res-nav-link">
                  الرئيسية
                </Link>
              </li>
            </>
          )}

          {hasAccess && (
            <li className="nav-item res-nav-item">
              <Link href={ordersLink} onClick={closeNav} className="nav-link res-nav-link">
                الطلبات
              </Link>
            </li>
          )}
          {hasAccess && isTutor && (
            <li className="nav-item res-nav-item tutor-calendar-nav-link mobile">
              <Dropdown className="custom-dropdown">
                <Dropdown.Toggle
                  className={
                    routePath === '/' || routePath.includes('/s/')
                      ? 'nav-link custom-nav-link home-nav-link my-2 mx-2'
                      : 'nav-link custom-nav-link my-2 mx-2'
                  }
                >
                  جدولي
                </Dropdown.Toggle>
                <Dropdown.Menu className="custom-dropdown-menu">
                  <Dropdown.Item
                    className="custom-dropdown-item"
                    onClick={() => push('/tutor/calendar')}
                  >
                    اضافة المواعيد المتاحة
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="custom-dropdown-item"
                    onClick={() => push('/tutor/students-orders')}
                  >
                    إضافة موعد مع طالب
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="custom-dropdown-item"
                    onClick={() =>
                      push({
                        pathname: '/tutor/calendar',
                        query: { isMyScheduler: true },
                      })
                    }
                  >
                    عرض مواعيدي المجدولة
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </li>
          )}

          {!hasAccess && (
            <>
              <li className="nav-item res-nav-item">
                <a
                  className="nav-link res-nav-link"
                  onClick={() => {
                    closeNav();
                    window.location.href = `/signin`;
                  }}
                  role="button"
                >
                  سجل الآن
                </a>
              </li>
              <li className="nav-item res-nav-item">
                <a
                  className="nav-link res-nav-link"
                  onClick={() => {
                    closeNav();
                    push(`/become-a-tutor`);
                  }}
                  role="button"
                >
                  سجل كمعلم
                </a>
              </li>
            </>
          )}

          {hasAccess && (
            <li className="nav-item res-nav-item">
              <a
                className="nav-link res-nav-link"
                href="#"
                role="button"
                onClick={() => {
                  closeNav();
                  logout();
                }}
              >
                تسجيل خروج
              </a>
            </li>
          )}
        </ul>
      </div>

      <div className={`header-container`}>
        <div
          className={`${styles.header}`}
          style={{
            position: isHomePage ? 'fixed' : 'relative',
          }}
        >
          <nav className={styles.nav}>
            <img
              onClick={() => push('/')}
              src="/logo_dark.png"
              alt="logo"
              className={styles.logo}
            />
            <ul className={styles.navList}>
              {hasAccess && (
                <li
                  className={isActive(ordersLink) ? `${styles.activeLink}` : ''}
                >
                  <Link href={ordersLink}>الطلبات</Link>
                </li>
              )}
              <li className={isActive('/') ? `${styles.activeLink}` : ''}>
                <Link href="/">الرئيسية</Link>
              </li>
              {hasAccess && isTutor && (
                <li className="nav-item res-nav-item tutor-calendar-nav-link">
                  <Dropdown className="custom-dropdown">
                    <Dropdown.Toggle
                      className={`nav-link custom-nav-link home-nav-link ${
                        isActive('/tutor/calendar') ||
                        isActive('/tutor/students-orders') ||
                        isActive('/tutor/calendar')
                          ? `${styles.activeLink}`
                          : ''
                      }`}
                    >
                      جدولي
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="custom-dropdown-menu">
                      <Dropdown.Item
                        className="custom-dropdown-item"
                        onClick={() => push('/tutor/calendar')}
                      >
                        اضافة المواعيد المتاحة
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item
                        className="custom-dropdown-item"
                        onClick={() => push('/tutor/students-orders')}
                      >
                        إضافة موعد مع طالب
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item
                        className="custom-dropdown-item"
                        onClick={() => {
                          push({
                            pathname: '/tutor/calendar',
                            query: { isMyScheduler: true },
                          });
                        }}
                      >
                        عرض مواعيدي المجدولة
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              )}
            </ul>
            {hasAccess ? (
              <div
                className={`${styles.userAvatarContainer} ${styles.dropdown} ${styles.avatarHeader}`}
              >
                <button
                  className={`${styles.userAvatarWrapper} ${styles.online}`}
                  onClick={() => setShowDropDown(!showDropDown)}
                >
                  <img
                    id="user-avatar"
                    src={
                      user?.photo ||
                      'https://faheem-assets-prod.s3.me-south-1.amazonaws.com/uploads/profiles/default-tutor-male.png'
                    }
                    alt="user-avatar"
                    className={styles.userAvatar}
                  />
                </button>
                {showDropDown && (
                  <div
                    id="user-info-container"
                    className={`${styles.userInfoContainer} ${styles.dropdownMenu} ${styles.fadeIn}`}
                    aria-labelledby="user-avatar-link"
                  >
                    <div className={styles.userInfoStatus}>
                      <div className={styles.userInfoAvatar}>
                        <div
                          className={`${styles.userAvatarWrapper} ${styles.online}`}
                        >
                          <img
                            src={
                              user?.photo ||
                              'https://faheem-assets-prod.s3.me-south-1.amazonaws.com/uploads/profiles/default-tutor-male.png'
                            }
                            alt="message-user-avatar"
                            className={styles.userAvatar}
                          />
                        </div>
                        <p className={styles.userName}>{user?.username}</p>
                      </div>
                    </div>
                    {hasAccess && (
                      <div className={styles.userInfoContainerUl}>
                        <button
                          className={styles.logoutButton}
                          onClick={() => {
                            setShowDropDown(false);
                            logout();
                          }}
                        >
                          تسجيل خروج
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div>
                <button
                  onClick={() => window.location.href = `/signin`}
                  className={styles.registerButton}
                >
                  سجل الآن
                </button>
                <button
                  className={styles.registerButton}
                  onClick={() => push('/become-a-tutor')}
                >
                  سجل كمعلم
                </button>
              </div>
            )}
          </nav>
        </div>

      </div>
    </>
  );
}
